import StyledWrapper from './style';

import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import WarningIcon from '@mui/icons-material/Warning';

/**
 * Props for the BackDialog component.
 *
 * @interface BackDialogProps
 * @property {boolean} isOpen - Controls whether the dialog is open.
 * @property {() => void} handleClose - Function to call when the user confirms navigation away.
 * @property {() => void} handleStay - Function to call when the user chooses to stay on the page.
 */
interface BackDialogProps {
	isOpen: boolean;
	handleClose: () => void;
	handleStay: () => void;
}

/**
 * BackDialog
 *
 * A confirmation dialog that warns users about unsaved changes when they attempt to navigate away from the application process/ stages/ forms creation modal.
 *
 * @param {BackDialogProps} props - The props for the BackDialog component.
 * @returns {JSX.Element} The rendered dialog component.
 */
const BackDialog = ({ isOpen, handleClose, handleStay }: BackDialogProps) => (
	<StyledWrapper.CustomDialog
		disableEscapeKeyDown
		open={isOpen}
		onClose={handleStay}
		aria-labelledby="responsive-dialog-title"
	>
		<StyledWrapper.CustomDialogTitle id="responsive-dialog-title">
			<WarningIcon color={'warning'} />
			You have unsaved changes!
		</StyledWrapper.CustomDialogTitle>
		<StyledWrapper.CustomDialogContent>
			<DialogContentText sx={{ fontWeight: '500' }}>
				{`You are trying to navigate away from this page`}
				<br />
				{`Are you sure?`}
			</DialogContentText>
		</StyledWrapper.CustomDialogContent>
		<DialogActions style={{ justifyContent: 'center' }}>
			<Button size="large" variant="outlined" color="warning" onClick={handleClose} autoFocus>
				YES - NAVIGATE AND LOSE CHANGES
			</Button>
			<Button size="large" variant="contained" autoFocus onClick={handleStay}>
				NO - STAY ON PAGE
			</Button>
		</DialogActions>
	</StyledWrapper.CustomDialog>
);

export default BackDialog;
